
import _ from 'lodash';
import { useCallback, useEffect, useMemo, useState } from 'react';
import { useSelector } from 'react-redux';
import { selectListItems } from '../../../../../../redux/library/selector';
import Table from '../../../../../../common/components/table-manager/v1.1/table';
import { useAppDispatch } from '../../../../../../hooks/hooks';
import { opennetworkDomains } from '../../../../../../redux/opennetwork-domains/action';
import { selectOpennetworkDomainsListItems } from '../../../../../../redux/opennetwork-domains/selector';

export const DBNGlobalDomainList = ({
  // dbnDomains,
  initiallySelectedDomains,
  // paginationData,
  // handleDBNGlobalDomainsSearch,
  // reloadGlobalDomains,
  closeModal,
  handleSubmit
}: any) => {
  const dispatch = useAppDispatch();
  const domainsListData = useSelector(selectOpennetworkDomainsListItems)

  const [pageData, setPageData] = useState(1);
  const [pageSize, setPageSize] = useState(10);
  const [searchCriteriaList, setSearchCriteriaList] = useState<any>([]);
  const [updatedDomainsList, setUpdatedDomainsList] = useState<any>([]);
  const libraryData = useSelector(selectListItems)
  const [isEnableImport, setIsEnableImport] = useState({});
  const columnDefs = useMemo(
    () => [
      {
        field: 'Sl',
        sortable: false,
        filter: false,
        isSortLabel: true,
        headerName: 'Sl',
        cellRenderer(params: any) {
          return parseInt(
            params.node.id,
            10
          ) + 1;
        },
      },
      {
        field: 'Name',
        headerName: 'Name',
        searchField: 'Name', sortable: true, filter: true, filterType: 'text'
      },
      {
        field: 'Code',
        headerName: 'Code',
        searchField: 'Code', sortable: true, filter: true, filterType: 'text'
      },
      {
        field: 'IsSubDomain',
        headerName: 'Is SubDomain',
        cellRenderer: 'yesNoRenderer',
        searchField: 'IsSubDomain', sortable: true, filter: true, filterType: 'text'
      },
      {
        field: 'ParentDomainName',
        headerName: 'Parent Domain',
        searchField: 'ParentDomainName', sortable: true, filter: true, filterType: 'text'
      },
    ],
    []
  );


  // API Call - Memoized
  const listDBNGlobalDomains = useCallback(() => {
    dispatch(opennetworkDomains.resetAction({ actionType: 'list' }))
    dispatch(opennetworkDomains.list({
      url: `https://dbnp.digiit.${process.env.REACT_APP_API_URL}/api/v6.1/organization/dbn/global-dbn-domains/dbn-fetch`,
      entity: 'dbnGlobalDomains',
      jsonData: {
        "Context": {},
        "Records": [
          {
            "IsSubDomain": null //to get all records 
          }
        ],
        "Pagination": {
          "PageNumber": pageData,
          "PageSize": pageSize,
          "SortField": "GlobalDBNDomainId",
          "SortOrder": "desc",
          Searches: searchCriteriaList,
        }
      }
    }))
  }, [dispatch, pageData, pageSize, searchCriteriaList]);

  useEffect(() => {
    listDBNGlobalDomains();
  }, [listDBNGlobalDomains]);

  // Search handler - Memoized
  const handleSearch = useCallback((data: any) => {
    let searchCriteria = []
    if (data?.column) {
      searchCriteria = [{
        FieldName: data?.column,
        FieldText: data?.column,
        FieldType: 'text',
        FilterOperatorId: 6,
        FieldValue: data?.value
      }]
    } else {
      searchCriteria = [{
        FieldName: "Name",
        FieldText: "Name",
        FieldType: 'text',
        FilterOperatorId: 6,
        FieldValue: data?.value
      }]
    }
    setSearchCriteriaList(searchCriteria);
    listDBNGlobalDomains();
  }, []);


  const additionButtons: any = [
    {
      svg:
        <svg xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24" width="24" height="24">
          <title>Reload this table</title>
          <path d="M21 3V8M21 8H16M21 8L18 5.29168C16.4077 3.86656 14.3051 3 12 3C7.02944 3 3 7.02944 3 12C3 16.9706 7.02944 21 12 21C16.2832 21 19.8675 18.008 20.777 14" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" />
        </svg>,
      // name: 'Reload',
      callback: () => handleReloadData(),
    },
  ];

  // Reload handler - Memoized
  const handleReloadData = useCallback(() => {
    // console.log("Reloading data...");
    listDBNGlobalDomains();
  }, []);

  // Select handler - Functional Update
  const handleSelect = useCallback((data: any) => {
    setUpdatedDomainsList((prev) => [...prev, ...data]);
  }, []);

  // Submit handler - Memoized
  const handleSelectDomains = useCallback(() => {
    handleSubmit(updatedDomainsList);
  }, [handleSubmit, updatedDomainsList]);

  useEffect(() => {
    console.log('updatedDomainsList', updatedDomainsList)
  }, [updatedDomainsList]);

  return (
    <>
      <Table
        columnData={columnDefs}
        rowData={domainsListData?.result?.items}
        setPageData={setPageData}
        setPageSize={setPageSize}
        enableFilter={true}
        onSearch={handleSearch}
        onSelect={handleSelect}
        searchCriteriaList={searchCriteriaList}
        paginationData={domainsListData?.result?.pagination}
        checkboxConfig={{
          allowMultiSelect: true,
          defaultSelectedIds: [],
          isDisabled: false,
          keyColumn: 'Name',
        }}
        additionButtons={additionButtons}
        headingName="DBN Global Domains"
      />

      <div className='flex w-full justify-end items-end'>
        <button
          onClick={closeModal}
          type='button'
          className="m-2 bg-blue-700 text-white rounded font-medium px-4 py-3 "
        >
          Close
        </button>
        <button
          disabled={updatedDomainsList?.length === 0}
          className={`m-2 ${updatedDomainsList?.length === 0 ? 'bg-disabled' : 'bg-blue-700'} text-white rounded font-medium px-4 py-3`}
          onClick={handleSelectDomains}

          type="submit"
        >
          Import Selected Domains
        </button>
      </div>
    </>
  )
}

export default DBNGlobalDomainList;
